// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-fee-schedule-services-provided{text-align:center;padding-top:30px;padding-bottom:30px;color:var(--color-body-grey)}", ""]);
// Exports
module.exports = exports;
